export default {"src":"/_next/static/media/brighterAI-logo-whitesvg.3c0086fe.svg","height":32,"width":104,"blurWidth":0,"blurHeight":0};